var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.utilityTab === "notes"
    ? _c(
        "div",
        {
          staticClass:
            "side-bar col-md-10 offset-md-1 col-lg-3 offset-lg-0 order-3",
        },
        [
          _c("div", { staticClass: "pt-lg-3" }, [
            !_vm.isAuthenticated
              ? _c(
                  "div",
                  { staticClass: "text-center" },
                  [
                    _c("p", { staticClass: "lead" }, [
                      _vm._v(
                        _vm._s(_vm._f("translate")("Want to make notes?"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "login",
                            params: { course: _vm.$route.params.course },
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm._f("translate")("Log in now")) +
                            "\n      "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  {},
                  [
                    _vm.lecture
                      ? _c("Notes", { attrs: { lecture: _vm.lecture } })
                      : _vm._e(),
                  ],
                  1
                ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }